var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:{'login': _vm.login},attrs:{"id":"app"}},[(_vm.login)?_c('loginmess'):_c('sidemenu'),(_vm.load)?_c('router-view'):_c('loading',{attrs:{"messages":_vm.messages}}),_c('errors')],1)}
var staticRenderFns = []

export { render, staticRenderFns }